"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureAd = void 0;
const authenticator_1 = require("../../../framework/authenticator");
const msal = __importStar(require("@azure/msal-browser"));
class AzureAd extends authenticator_1.BaseAuthenticator {
    constructor(session, msalConfig) {
        super(session);
        this.getRefreshToken = () => {
            /*
              WARNING:
              This is a hack to get refresh token from cache, but the library doesn't provide RefreshToken.
              So, we don't recommend to use this method. It could stop working in the future.
            */
            try {
                const storage = this.myMSALObj.getTokenCache().storage.browserStorage.windowStorage;
                const data = Object.values(storage).find((item) => {
                    try {
                        return JSON.parse(item).credentialType === 'RefreshToken';
                    }
                    catch (_a) {
                        return false;
                    }
                }) || '';
                return JSON.parse(data).secret;
            }
            catch (e) {
                console.error(e);
                throw new Error('Check getRefreshToken method in AzureAd authenticator.');
            }
        };
        this.msalConfig = msalConfig;
        this.myMSALObj = new msal.PublicClientApplication(msalConfig);
    }
    get myMsalObj() {
        return this.myMSALObj;
    }
    handleResponse(loginRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (this.response !== null) {
                return this.response;
            }
            const currentAccounts = ((_a = this.myMSALObj) === null || _a === void 0 ? void 0 : _a.getAllAccounts()) || [];
            if (currentAccounts.length === 0) {
                yield ((_b = this.myMSALObj) === null || _b === void 0 ? void 0 : _b.loginRedirect(loginRequest));
            }
            else if (currentAccounts.length === 1) {
                const { scopes } = loginRequest;
                this.response = yield ((_c = this.myMSALObj) === null || _c === void 0 ? void 0 : _c.acquireTokenSilent({ scopes, account: currentAccounts[0] }));
            }
            return this.response;
        });
    }
    doLogin(loginData) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            this.response = yield this.myMSALObj.handleRedirectPromise();
            yield this.handleResponse(loginData);
            const refreshToken = this.getRefreshToken();
            let sessionData;
            if (this.response) {
                sessionData = {
                    accessToken: this.response.accessToken,
                    refreshToken,
                    idToken: this.response.idToken,
                    customerSessionId: this.response.correlationId,
                    email: (_a = this.response.account) === null || _a === void 0 ? void 0 : _a.username,
                    username: (_b = this.response.account) === null || _b === void 0 ? void 0 : _b.name,
                    roles: (_c = this.response.idTokenClaims) === null || _c === void 0 ? void 0 : _c['roles'],
                    expiresIn: this.response.expiresOn,
                    timestamp: Date.now(),
                    idTokenClaims: this.response.idTokenClaims,
                };
            }
            return sessionData;
        });
    }
    doLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const username = ((_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.username) || '';
            const logoutRequest = {
                account: (_c = this.myMSALObj) === null || _c === void 0 ? void 0 : _c.getAccountByUsername(username),
                postLogoutRedirectUri: this.msalConfig.auth.redirectUri,
            };
            (_d = this.myMSALObj) === null || _d === void 0 ? void 0 : _d.logoutRedirect(logoutRequest);
        });
    }
}
exports.AzureAd = AzureAd;
//# sourceMappingURL=index.js.map